import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import products from '../pages/ProductData';

const Footer = () => {
    return (
        <Box component="footer" sx={{ py: 6, backgroundColor: '#0b1727', color: 'white' }}>
            <Container maxWidth="lg">
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }}>
                    <Box>
                        <Typography variant="h5">Epytome IT</Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.72)', mt: 1 }}>
                            Crafting Tomorrow’s Solutions with Today’s Expertise
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.56)', mt: 2 }}>
                            © {new Date().getFullYear()} Epytome IT. All rights reserved.
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <Button component={Link} to="/about" sx={{ color: 'white' }}>About</Button>
                        <Button component={Link} to="/services" sx={{ color: 'white' }}>Services</Button>
                        <Button component={Link} to={products[0].path} sx={{ color: 'white' }}>{products[0].name}</Button>
                        <Button component="a" href={products[0].externalUrl} target="_blank" rel="noreferrer" variant="outlined" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.32)' }}>
                            Visit Product
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
};

export default Footer;
